var chars = require('./chars');

module.exports = function splice(str, i, howmany, substr) {
  var arr = chars(str);
  arr.splice(~~i, ~~howmany, substr);
  return arr.join('');
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/splice.js
// module id = 805
// module chunks = 0